import { Map, OrderedSet, fromJS } from "immutable";
import { combineReducers } from "redux";
import {
  ASSETS_RESOURCE,
  CONTENT_FEEDS_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  DEVICE_UNGROUP_WRAPERS_RESOURCE,
  DEVICES_RESOURCE,
  PLAYLIST_ITEMS_RESOURCE,
  CHANNELS_RESOURCE,
  SCHEDULED_CONTENT_RESOURCE,
  SCHEDULED_DAILY_CONTENT_RESOURCE,
  SPECIAL_CONTENT_RESOURCE,
  TICKERS_RESOURCE,
  SUBUSER_RESOURCE,
  USERPROFILE_RESOURCE,
} from "signoxe/api/resources";
import {
  ADD_FILE_TO_CAMPAIGN,
  DELETE_RESOURCE_FAILURE,
  DELETE_RESOURCE_REQUEST,
  DELETE_RESOURCE_SUCCESS,
  FETCH_RESOURCE_FAILURE,
  FETCH_RESOURCE_REQUEST,
  FETCH_RESOURCE_SUCCESS,
  PATCH_RESOURCE_FAILURE,
  PATCH_RESOURCE_REQUEST,
  PATCH_RESOURCE_SUCCESS,
  POST_RESOURCE_FAILURE,
  POST_RESOURCE_REQUEST,
  POST_RESOURCE_SUCCESS,
  PUT_RESOURCE_SUCCESS,
  UPLOAD_ASSET_SUCCESS,
} from "signoxe/constants/actionTypes";
import { assetFromId } from "signoxe/selectors";

export const resourceReducer = (resources) => {
  const ids = (state = OrderedSet(), action) => {
    if (!resources.includes(action.resource)) return state;
    switch (action.type) {
      case FETCH_RESOURCE_SUCCESS:
        if (action.single) {
          return state.union([action.response.result]);
        }
        return action.refresh
          ? OrderedSet(action.response.result)
          : state.union(action.response.result);
      case UPLOAD_ASSET_SUCCESS:
        return OrderedSet.of(action.response.result).union(state);
      case POST_RESOURCE_SUCCESS:
        return OrderedSet.of(action.response.result).union(state);
      case DELETE_RESOURCE_SUCCESS:
        if (action.subResource === null)
          return state.filter((id) => id != action.resourceId);
        else return state;
      default:
        return state;
    }
  };
  const isFetching = (state = false, action) => {
    if (!resources.includes(action.resource)) return state;
    switch (action.type) {
      case FETCH_RESOURCE_REQUEST:
      case PATCH_RESOURCE_REQUEST:
      case DELETE_RESOURCE_REQUEST:
      case POST_RESOURCE_REQUEST:
        return true;
      case FETCH_RESOURCE_SUCCESS:
      case FETCH_RESOURCE_FAILURE:
      case PATCH_RESOURCE_SUCCESS:
      case PATCH_RESOURCE_FAILURE:
      case DELETE_RESOURCE_SUCCESS:
      case DELETE_RESOURCE_FAILURE:
      case POST_RESOURCE_SUCCESS:
      case POST_RESOURCE_FAILURE:
        return false;
      default:
        return state;
    }
  };

  const error = (state = null, action) => {
    if (!resources.includes(action.resource)) return state;
    switch (action.type) {
      case FETCH_RESOURCE_FAILURE:
      case PATCH_RESOURCE_FAILURE:
      case DELETE_RESOURCE_FAILURE:
        return action.error;
      case FETCH_RESOURCE_REQUEST:
      case PATCH_RESOURCE_REQUEST:
      case DELETE_RESOURCE_REQUEST:
      case FETCH_RESOURCE_SUCCESS:
      case PATCH_RESOURCE_SUCCESS:
      case DELETE_RESOURCE_SUCCESS:
        return null;
      default:
        return state;
    }
  };

  return combineReducers({
    ids,
    isFetching,
    error,
  });
};

const updateAssetTag = (state, action) => {
  if (action.resource === ASSETS_RESOURCE && action.tag) {
    // console.log(action);

    let newTags = action.response.tags;

    const devId = action.response.id.toString();
    
    const oldTags = state.getIn(["assets", devId, "tags"], []);

    const arr1 = oldTags.toJS();
    const arr2 = newTags;

    function getDifference(a, b) {
      if(arr1.length > arr2.length){
        return a.filter(element => {
          return !b.includes(element);
        });
      }else{
        return b.filter(element => {
          return !a.includes(element);
        });
      }
    }

    if(arr2.length != arr1.length){
        if(arr2.length > arr1.length){
          return state.updateIn(["assets", devId, "tags"], (tags) => tags.push(getDifference(arr1, arr2)[0]) )
        }else if(arr1.length > arr2.length){
          return state.updateIn(["assets", devId, "tags"], (tags) => tags.filter((d) => d != getDifference(arr1, arr2)[0]) )
        }else return state;
    }
  } else {
    return state;
  }
};

const updateAddedTickers = (state, action) => {
  if (action.resource === TICKERS_RESOURCE) {
    const newId = action.response.result;
    const seriesId =
      action.response.entities.tickers[newId].ticker_series.toString();

    return state.updateIn(["tickerSeries", seriesId, "tickers"], (tickers) =>
      tickers.push(newId)
    );
  } else return state;
};

const updateDeletedTicker = (state, action) => {
  if (action.resource === TICKERS_RESOURCE) {
    const deletedId = action.resourceId.toString();
    const seriesId = state
      .getIn(["tickers", deletedId, "ticker_series"])
      .toString();

    return state.updateIn(["tickerSeries", seriesId, "tickers"], (tickers) =>
      tickers.filter((i) => i != deletedId)
    );
  } else return state;
};

const updateAddedPlaylistItem = (state, action) => {
  if (action.resource === PLAYLIST_ITEMS_RESOURCE) {
    const newId = action.response.result;
    const playlistId =
      action.response.entities.playlistItems[newId].playlist.toString();

    return state.updateIn(["playlists", playlistId, "items"], (items) =>
      items.unshift(newId)
    );
  } else return state;
};

const updateDeletedAssetItem = (state, action) => {
  if (action.resource === ASSETS_RESOURCE) {
    console.log("updateDeletedAssetItem() action = ", action);
    const deletedId = action.resourceId.toString();
    //const deletedAsset = state.entities.getIn(["assets", id.toString()]);

    const deletedAsset = state.getIn(["assets", deletedId]);

    console.log("updateDeletedAssetItem deletedAsset = ", deletedAsset);

    return state;
    // return state.update("assets", (assets) =>
    //   assets.update((asset) =>
    //     asset.get("id") == deletedId ? asset.set("id", null) : asset
    //   )
    // );
  } else return state;
};

const updateDeletedPlaylistItem = (state, action) => {
  if (action.resource === PLAYLIST_ITEMS_RESOURCE) {
    const deletedId = action.resourceId.toString();
    const playlistId = state
      .getIn(["playlistItems", deletedId, "playlist"])
      .toString();

    return state.updateIn(["playlists", playlistId, "items"], (items) =>
      items.filter((i) => i != deletedId)
    );
  } else return state;
};

const updateDeleteDeviceGroup = (state, action) => {
  if (
    action.resource === DEVICE_GROUPS_RESOURCE &&
    action.subResource === null
  ) {
    const deletedGroup = action.resourceId.toString();

    return state.update("devices", (devices) =>
      devices.update((device) =>
        device.get("group") == deletedGroup ? device.set("group", null) : device
      )
    );
  } else return state;
};

const updateDeleteContentFeed = (state, action) => {
  if (
    action.resource === CONTENT_FEEDS_RESOURCE &&
    action.subResource === null
  ) {
    const stateObj = state.toJS();
    return fromJS({
      ...stateObj,
      deviceGroups: Object.keys(stateObj.deviceGroups).reduce(
        (newDeviceGroups, groupId) => ({
          ...newDeviceGroups,
          [groupId]: {
            ...stateObj.deviceGroups[groupId],
            feed_chain: stateObj.deviceGroups[groupId].feed_chain.filter(
              (feed) => feed.id !== action.resourceId
            ),
          },
        }),
        {}
      ),
    });
  } else return state;
};

// Daily schedule
function updateDailyAddedSchedule(state, action) {
  if (action.resource === SCHEDULED_DAILY_CONTENT_RESOURCE) {
    const schId = action.response.result;
    const devGrpId =
      action.response.entities.scheduledDailyContent[schId].device_group.toString();

    return state.updateIn(["deviceGroups", devGrpId, "daily_schedule"], (daily_schedule) =>
    daily_schedule.push(schId)
    );
  } else return state;
}

function updateDailyDeletedSchedule(state, action) {
  if (action.resource === SCHEDULED_DAILY_CONTENT_RESOURCE) {
    const deletedId = action.resourceId.toString();
    const deviceGroupId = state
      .getIn(["scheduledDailyContent", deletedId, "device_group"])
      .toString();

    return state.updateIn(
      ["deviceGroups", deviceGroupId, "daily_schedule"],
      (items) => items.filter((i) => i != deletedId)
    );
  } else return state;
}

const updateChangedContentFeeds = (state, action) => {
  if (action.resource === CONTENT_FEEDS_RESOURCE) {
    const changedFeeds = action.response.entities.feeds;
    let stateObj = state.toJS();
    const feedKeys = Object.keys(changedFeeds);
    for (const feedId of feedKeys) {
      stateObj = {
        ...stateObj,
        deviceGroups: Object.keys(stateObj.deviceGroups).reduce(
          (newDeviceGroups, groupId) => ({
            ...newDeviceGroups,
            [groupId]: {
              ...stateObj.deviceGroups[groupId],
              feed_chain: stateObj.deviceGroups[groupId].feed_chain.map(
                (feed) => {
                  if (feed.id !== parseInt(feedId, 10)) {
                    return feed;
                  }
                  return changedFeeds[feedId];
                }
              ),
            },
          }),
          {}
        ),
      };
    }
    return fromJS(stateObj);
  } else {
    return state;
  }
};

const updateChangedDeviceGroups = (state, action) => {
  if (action.resource === DEVICES_RESOURCE) {
    console.log(state)
    console.log(action)
    console.log(action.response.result)
    const devId = action.response.result.toString();
    const oldGroup = state.getIn(["devices", devId, "group"], "").toString();
    const oldTags = state.getIn(["devices", devId, "tags"], []);
    const newTags = action.response.entities.devices[devId].tags;
    console.log(devId)
    console.log(oldGroup)

    console.log(oldTags)
    console.log(newTags)

    const arr1 = oldTags.toJS();
    const arr2 = newTags;

    function getDifference(a, b) {
      if(arr1.length > arr2.length){
        return a.filter(element => {
          return !b.includes(element);
        });
      }else{
        return b.filter(element => {
          return !a.includes(element);
        });
      }
      
    }

    if(action.response.entities.devices[devId].group != null){ 
      if (oldGroup === "") return state;
      const newGroup = action.response.entities.devices[devId].group.toString();

      if (oldGroup === newGroup) {
        console.log('djjsdjlskjdkj')
        if(arr2.length > arr1.length){
          return state.updateIn(["devices", devId, "tags"], (tags) => tags.push(getDifference(arr1, arr2)[0]) )
        }else if(arr1.length > arr2.length){
          return state.updateIn(["devices", devId, "tags"], (tags) => tags.filter((d) => d != getDifference(arr1, arr2)[0]) )
        }else return state;
      } else {
        return state
          .updateIn(["deviceGroups", newGroup, "devices"], (devices) =>
            devices.push(devId)
          )
          .updateIn(["deviceGroups", oldGroup, "devices"], (devices) =>
            devices.filter((d) => d != devId)
          );
      }
    }else{
      return state.updateIn(["deviceGroups", oldGroup, "devices"], (devices) =>
        devices.filter((d) => d != devId)
      );
    }
    
  } else {
    return state;
  }
};

const updateChangedGroupsTag = (state, action) => {
  if (action.resource === DEVICE_GROUPS_RESOURCE || action.resource === DEVICE_UNGROUP_WRAPERS_RESOURCE) {
    console.log(state)
    console.log(action)
    console.log(action.response.result)
    let groupType = ''
    let newTags

    const devId = action.response.result.toString();
    if(action.resource === DEVICE_GROUPS_RESOURCE){ 
      groupType = 'deviceGroups'
      newTags = action.response.entities.deviceGroups[devId].tags;
    }else if(action.resource === DEVICE_UNGROUP_WRAPERS_RESOURCE){
      groupType = 'deviceUngroupWrapers'
      newTags = action.response.entities.deviceUngroupWrapers[devId].tags;
    }

    
    const oldTags = state.getIn([groupType, devId, "tags"], []);
    
    console.log(devId)

    console.log(oldTags.toJS())
    console.log(newTags)

    const arr1 = oldTags.toJS();
    const arr2 = newTags;

    function getDifference(a, b) {
      if(arr1.length > arr2.length){
        return a.filter(element => {
          return !b.includes(element);
        });
      }else{
        return b.filter(element => {
          return !a.includes(element);
        });
      }
      
    }

    if(arr2.length != arr1.length){
        if(arr2.length > arr1.length){
          return state.updateIn([groupType, devId, "tags"], (tags) => tags.push(getDifference(arr1, arr2)[0]) )
        }else if(arr1.length > arr2.length){
          return state.updateIn([groupType, devId, "tags"], (tags) => tags.filter((d) => d != getDifference(arr1, arr2)[0]) )
        }else return state;
    }
  } else {
    return state;
  }
};

function updateAddedSchedule(state, action) {
  if (action.resource === SCHEDULED_CONTENT_RESOURCE) {
    const schId = action.response.result;
    const devGrpId =
      action.response.entities.scheduledContent[schId].device_group.toString();

    return state.updateIn(["deviceGroups", devGrpId, "schedule"], (schedule) =>
      schedule.push(schId)
    );
  } else return state;
}

function updateDeletedSchedule(state, action) {
  if (action.resource === SCHEDULED_CONTENT_RESOURCE) {
    const deletedId = action.resourceId.toString();
    const deviceGroupId = state
      .getIn(["scheduledContent", deletedId, "device_group"])
      .toString();

    return state.updateIn(
      ["deviceGroups", deviceGroupId, "schedule"],
      (items) => items.filter((i) => i != deletedId)
    );
  } else return state;
}

function updateAddedSpecialContent(state, action) {
  if (action.resource === SPECIAL_CONTENT_RESOURCE) {
    const splId = action.response.result.toString();
    const groupId =
      action.response.entities.specialContent[splId].device_group.toString();

    return state.updateIn(["deviceGroups", groupId, "specials"], (specials) =>
      specials.push(splId)
    );
  } else return state;
}

function updateDeletedSpecialContent(state, action) {
  if (action.resource === SPECIAL_CONTENT_RESOURCE) {
    const deletedId = action.resourceId.toString();
    const groupId = state
      .getIn(["specialContent", deletedId, "device_group"])
      .toString();

    return state.updateIn(["deviceGroups", groupId, "specials"], (items) =>
      items.filter((i) => i != deletedId)
    );
  } else return state;
}

function updateDeletedPriorityMessage(state, action) {
  if (
    action.resource === DEVICE_GROUPS_RESOURCE &&
    action.subResource === "priority_message"
  ) {
    const groupId = action.resourceId.toString();

    return state.updateIn(
      ["deviceGroups", groupId, "priority_message", "activated_on"],
      () => null
    );
  } else return state;
}

export const entities = (
  state = Map({
    campaign: Map(),
    assets: Map(),
    devices: Map(),
    deviceGroups: Map(),
    deviceUngroupWrapers: Map(),
    feeds: Map(),
    playlists: Map(),
    playlistsV2: Map(),
    playlistItems: Map(),
    channels: Map(),
    tickers: Map(),
    tickerSeries: Map(),
    scheduledContent: Map(),
    scheduledDailyContent: Map(),
    specialContent: Map(),
    userProfile: Map(),
    webAssetTemplates: Map(),
    customTemplates: Map(),
    notifications: Map(),
    subUsers: Map(),
    profileUser: Map(),
    listTags: Map(),
  }),
  action
) => {
  if (action.type === PATCH_RESOURCE_SUCCESS) {
    state = updateChangedDeviceGroups(state, action);
    // state = updateChangedGroupsTag(state, action);
    state = updateChangedContentFeeds(state, action);
  }
  if (action.response && action.response.entities) {
    if (action.resource === SUBUSER_RESOURCE) {
      state = state.merge(action.response.entities);
    }
    if (action.resource === USERPROFILE_RESOURCE) {
      state = state.merge(action.response.entities);
    }
    if (action.refresh && action.resource === ASSETS_RESOURCE) {
      state = state.merge(action.response.entities);
    } else {
      if (
        action.type === PATCH_RESOURCE_SUCCESS &&
        action.resource === CHANNELS_RESOURCE
      ) {
        state = state.mergeIn(["channels"], action.response.entities.channels);
      } else {
        state = state.mergeDeep(action.response.entities);
      }
    }
  }

  if (action.type === POST_RESOURCE_SUCCESS) {
    state = updateAddedTickers(state, action);
    // state = updateAddedPlaylistItem(state, action);
    state = updateAddedSchedule(state, action);
    state = updateDailyAddedSchedule(state, action);
    state = updateAddedSpecialContent(state, action);
  } else if (action.type === DELETE_RESOURCE_SUCCESS) {
    // state = updateDeletedPlaylistItem(state, action);
    state = updateDeletedAssetItem(state, action);
    state = updateDeletedTicker(state, action);
    state = updateDeleteDeviceGroup(state, action);
    state = updateDeleteContentFeed(state, action);
    state = updateDeletedSchedule(state, action);
    state = updateDailyDeletedSchedule(state, action);
    state = updateDeletedSpecialContent(state, action);
    state = updateDeletedPriorityMessage(state, action);
  } else if (action.type === PUT_RESOURCE_SUCCESS) {
    state = updateAssetTag(state, action);
  }

  return state;
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/resourceReducer.js